import * as React from 'react';
import { Button } from 'src/shared';
import { breakpoints, useMediaQuery } from 'src/shared/hooks/use-media-query';
import { Container } from 'src/shared/ui/layout';

export const DownloadAndroidApp = () => {
  const isMobile = useMediaQuery(
    [breakpoints.mobile, breakpoints.tablet, breakpoints.desktop],
    [true, true, false],
  );

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href =
      'https://yau-android-app.s3.us-east-1.amazonaws.com/app-release.apk';
    link.download = 'yauCoachPortal.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Container {...(isMobile ? { $width: '360px' } : {})}>
      <h1 className="text-center mb-32">Android App</h1>
      <div className="text-center">
        <Button onClick={handleDownload} className="btn btn-primary">
          Download Android App
        </Button>
      </div>
    </Container>
  );
};
